export const NEWSLOGOS_CONFIG_DATA = [
        {
            url: '../../assets/resources/Prlogo_firstslide/Ani-logo.png',
            link: 'https://www.aninews.in/news/business/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120741/',
            aosdelay:400, 
            alttext:'aninews'  
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/AP_Mirror.png',
            link: 'https://www.andhrapradeshmirror.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300,
            alttext:'andhrapradeshmirror'   
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/bignews.png',
            link: 'https://www.bignewsnetwork.com/news/274432487/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza',
            aosdelay:200, 
            alttext:'bignewsnetwork'  
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/Haryana_Today.png',
            link: 'https://www.haryanatoday.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300,  
            alttext:'haryanatoday'   
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/business-standard.png',
            link: 'https://www.business-standard.com/content/press-releases-ani/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza-124062500419_1.html',
            aosdelay:300,
            alttext:'business-standard'     
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/daily_prabhat.png',
            link: 'https://www.dailyprabhat.com/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/',
            aosdelay:400,
            alttext:'dailyprabhat'     
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/gujrat-varta.png',
            link: 'https://www.gujaratvarta.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:200, 
            alttext:'gujaratvarta'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/gujrat_samachar.png',
            link: 'https://www.gujaratsamachar.news/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,
            alttext:'gujaratsamachar'     
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/Bihar_Times.png',
            link: 'https://www.bihartimes.news/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,
            alttext:'bihartimes'   
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/IEO.png',
            link: 'https://www.indianeconomicobserver.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,  
            alttext:'indianeconomicobserver'   
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/inn.png',
            link: 'https://www.indiannewsnetwork.net/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'indiannewsnetwork'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/karnataka_live.png',
            link: 'https://www.karnatakalive.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,  
            alttext:'karnatakalive'   
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/Kashmir_Breaking_News.png',
            link: 'https://www.kashmirbreakingnews.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'kashmirbreakingnews'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/kbk-times.png',
            link: 'https://kbktimes.com/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/',
            aosdelay:400,
            alttext:'kbktimes'     
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/newlokmat-times.png',
            link: 'https://www.lokmattimes.com/business/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/',
            aosdelay:200, 
            alttext:'lokmattimes'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/WB_samachar.png',
            link: 'https://www.westbengalkhabar.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:200, 
            alttext:'westbengalkhabar'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/MP-Chronicle.png',
            link: 'https://www.madhyapradeshchronicle.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300,
            alttext:'madhyapradeshchronicle'     
          },         
          {
            url: '../../assets/resources/Prlogo_firstslide/news_network.png',
            link: 'https://news9network.com/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/',
            aosdelay:400, 
            alttext:'news9network'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/UP-today.png',
            link: 'https://www.uptoday.news/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'uptoday'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/telengana_journal.png',
            link: 'https://www.telanganajournal.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'telanganajournal'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/the_print.png',
            link: 'https://theprint.in/ani-press-releases/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/2146169/',
            aosdelay:300, 
            alttext:'theprint'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/dailyhunt.png',
            link: 'https://m.dailyhunt.in/news/india/english/lokmattimes+english-epaper-lokmaten/kalpita+technologies+celebrates+6+years+of+innovation+with+an+exciting+anniversary+extravaganza-newsid-n619284480?sm=Y',
            aosdelay:300,
            alttext:'dailyhunt'     
          },
          
          {
            url: '../../assets/resources/Prlogo_firstslide/webindia.png',
            link: 'https://news.webindia123.com/news/articles/business/20240625/4208992.html',
            aosdelay:400, 
            alttext:'webindia123'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Bihar-24x7.png',
            link: 'https://www.bihar24x7.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300,  
            alttext:'bihar24x7'   
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/British_Columbia_Times.png',
            link: 'https://www.britishcolumbiatimes.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'britishcolumbiatimes'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Chatisgarh_Today.png',
            link: 'https://www.chhattisgarhtoday.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'chhattisgarhtoday'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/DLN.png',
            link: 'https://www.delhilivenews.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:200,  
            alttext:'delhilivenews'   
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/england-news-portal.png',
            link: 'https://www.englandnewsportal.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'englandnewsportal'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/fedral_dispatch.png',
            link: 'https://www.federaldespatch.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300,
            alttext:'federaldespatch'     
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Florida_breaking_news.png',
            link: 'https://www.floridabreakingnews.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'floridabreakingnews'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Himanchal-Patrika.png',
            link: 'https://www.himachalpatrika.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'himachalpatrika'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/htds.png',
            link: 'https://www.htsyndication.com/asian-news-international/article/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/82458300',
            aosdelay:200, 
            alttext:'htsyndication'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Srilanka_island.png',
            link: 'https://www.srilankaislandnews.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'srilankaislandnews'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/LY_LOGO.png',
            link: 'https://www.latestly.com/agency-news/business-news-kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza-6062939.html',
            aosdelay:300, 
            alttext:'latestly'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/maharashtra_news.png',
            link: 'https://www.maharashtrasamachar.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,  
            alttext:'maharashtrasamachar'   
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Miami_News_Herald.png',
            link: 'https://www.miaminewsherald.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'miaminewsherald'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/northeast_times.png',
            link: 'https://www.northeasttimes.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:200,
            alttext:'northeasttimes'     
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Odish_Post.png',
            link: 'https://www.odishapost.news/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'odishapost'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/punjab-live.png',
            link: 'https://www.punjablive.news/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'punjablive'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/rajasthan_ki_khabar.png',
            link: 'https://www.rajasthankikhabar.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'rajasthankikhabar'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Kashmir_Newsline.png',
            link: 'https://www.kashmirnewsline.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400, 
            alttext:'kashmirnewsline'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Toronto_Sun_Times.png',
            link: 'https://www.torontosuntimes.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:200, 
            alttext:'torontosuntimes'    
          },
          {
            url: '../../assets/resources/Prlogo_firstslide/South_India_news.png',
            link: 'https://www.southindianews.in/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'southindianews'    
          },
          
          {
            url: '../../assets/resources/Prlogo_secondslide/up18.png',
            link: 'https://up18news.com/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza/',
            aosdelay:300, 
            alttext:'up18news'    
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/US_World_Today.png',
            link: 'https://www.usworldtoday.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:400,
            alttext:'usworldtoday'     
          },
          {
            url: '../../assets/resources/Prlogo_secondslide/Vanakkam_TN.png',
            link: 'https://www.vanakkamtamilnadu.com/news/kalpita-technologies-celebrates-6-years-of-innovation-with-an-exciting-anniversary-extravaganza20240625120730/',
            aosdelay:300, 
            alttext:'vanakkamtamilnadu'    
          },
         
   
];